module.exports = __webpack_public_path__ + "images/emoji/ring.9531d00e47234717ee32.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ring.png
// module id = 7kbn
// module chunks = 2